import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';
import {
  InputLabel,
  StripeMiniLogo,
  CreditCardLine,
  ButtonText,
} from './styled';
import CustomerCard from '../checkout/CustomerCard';
import Loading from '../../components/Loading';
import Colors from '../../styles/colors';

class UserCreditCard extends Component {
  render() {
    const {
      userId,
      card,
      onBeforeCardCreated,
      onNewCardCreated,
      onBillingUpdate,
    } = this.props;

    const {
      address_line1: addressLine1 = '',
      address_city: addressCity = '',
      address_state: addressState = '',
      address_zip: addressZip = '',
      address_country: addressCountry = 'US',
      id: sourceId = '',
      customer: customerId = '',
      brand = '',
      last4 = '',
    } = card;

    return (
      <CustomerCard
        userId={userId}
        sourceId={sourceId}
        customerId={customerId}
        billing={{
          addressLine1,
          addressCity,
          addressState,
          addressZip,
          addressCountry,
        }}
        card={{
          brand,
          last4,
        }}
        onBeforeCardCreated={onBeforeCardCreated}
        onNewCardCreated={onNewCardCreated}
        onBillingUpdate={onBillingUpdate}
        showBillingFields={{
          addressLine1: true,
          addressCity: true,
          addressState: true,
          addressZip: true,
          addressCountry: true,
        }}
        customRenderer={() => ({
          editBilling,
          setupNewCard,
          renderBilling,
        }) => {
          const hasCustomer = !isEmpty(card);
          const newCardBtnTxt = hasCustomer ? 'New Credit Card' : 'Add a Credit Card';
          return (
            <React.Fragment>
              {hasCustomer && (
                <React.Fragment>
                  <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      {renderBilling()}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <strong>{brand} {` **** ***** ${last4}`}</strong>
                    </div>
                  </div>
                </React.Fragment>
              )}
              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div className="card-actions">
                    {hasCustomer && (
                      <ButtonText onClick={editBilling}>Edit</ButtonText>
                    )}
                    <ButtonText onClick={() => {
                      // if there's no customer yet, force it create one
                      const forceNewCustomer = !hasCustomer;
                      setupNewCard(forceNewCustomer);
                    }}>{newCardBtnTxt}</ButtonText>
                  </div>
                </div>
              </div>
            </React.Fragment>
          );
        }}
        customActionButtons={{
          newcard: {
            btnLabel: 'Create Card',
            title: 'New Card Details',
          },
        }}
      />
    );
  }
}

UserCreditCard.propTypes = {
  userId: PropTypes.string,
  card: PropTypes.object,
  onBeforeCardCreated: PropTypes.func,
  onNewCardCreated: PropTypes.func,
  onBillingUpdate: PropTypes.func,
};

UserCreditCard.defaultProps = {
  userId: '',
  card: {},
  onBeforeCardCreated: () => {},
  onNewCardCreated: () => {},
  onBillingUpdate: () => {},
};

export default UserCreditCard;
